import React from 'react';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';
import ColButton from '../../../Elements/ColButton';
import OfficeOrGroupSelect from '../../../Elements/InputComponents/BaseInputs/Selectors/OfficeOrGroupSelect';
import PanelBorder from '../../../Elements/PanelBorder';
import InputWithClear from '../../../Elements/InputComponents/InputWithClear';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

class ReportingFilterBox extends React.Component {
  static defaultProps = {
    panelClickOnCancel: () => alert('deault clickOnCancel'),
    startExport: () => alert('deault startExport'),
    filter: null,
    startSearch: () => {},
    exportLoading: () => {},
    screenLoading: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      filter: props.filter,
      advanced: false,
    };
  }

  componentDidMount() {}

  renderAdvancedSearchButton() {
    return (
      <ColButton
        text='Advanced Search'
        onClick={() => {
          this.setState({ advanced: !this.state.advanced });
        }}
        icon={this.state.advanced ? 'fa-solid fa-caret-up' : 'fa-solid fa-caret-down'}
      />
    );
  }

  clickOnSubmitButton() {
    this.props.startSearch(this.state.filter);
  }

  renderInputField(fieldName, labelText, colwidth, type, validityCheckerFunction) {
    if (validityCheckerFunction === undefined) {
      validityCheckerFunction = () => {};
    }

    return (
      <div className={colwidth}>
        <InputWithClear
          fieldName={fieldName}
          labelText={labelText}
          type={type}
          value={this.state.filter[fieldName]}
          validityChecker={validityCheckerFunction}
          onChange={(fieldName, newValue) => {
            const tempFilter = { ...this.state.filter };
            tempFilter[fieldName] = newValue;
            if (fieldName === 'ServiceId' && newValue.includes('//')) {
              tempFilter.ClientId = newValue.split('//')[1];
            }
            if (fieldName === 'ClientId') {
              tempFilter.ServiceId = '';
            }
            if (fieldName === 'UseActualMonth' && tempFilter.UseActualMonth) {
              tempFilter.StartDate = dateTimeHelper.firstDayOfTheActualMonth();
              tempFilter.EndDate = dateTimeHelper.lastDayOfTheActualMonth();
            }

            this.setState({ filter: tempFilter });
          }}
          idFilter={fieldName === 'ServiceId' ? this.state.filter.ClientId : ''}
        />
      </div>
    );
  }

  renderCheckBox(key) {
    return (
      <div className='row'>
        <div className='col text-right'>{key}</div>
        <div className='col'>
          <input
            type='checkbox'
            checked={this.state.filter[key]}
            onChange={(e) => {
              const temp = { ...this.state.filter };
              temp[key] = e.target.checked;
              this.setState({ filter: temp });
            }}
          />
        </div>
      </div>
    );
  }

  renderStatusCheckBoxes(colwidth) {
    return (
      <div className={colwidth}>
        <div className='text-center '>Status</div>
        <div className='border rounded'>
          {this.renderCheckBox('Created')}
          {this.renderCheckBox('ClientConfirmed')}
          {this.renderCheckBox('OnHold')}
          {this.renderCheckBox('Closed')}
          {this.renderCheckBox('Cancelled')}
        </div>
      </div>
    );
  }

  renderOfficeMultiselect(labelText, colwidth) {
    return (
      <div className={colwidth}>
        <div className='text-center '>{labelText}</div>
        <OfficeOrGroupSelect
          value={this.state.filter.SelectedOfficeIds}
          fieldName='SelectedOfficeIds'
          isMulti={true}
          onChange={(_, officeIds) => {
            const tempFilter = { ...this.state.filter, SelectedOfficeIds: officeIds };
            this.setState({ filter: tempFilter });
          }}
        />
      </div>
    );
  }

  renderButtons() {
    const screenIcon = this.props.screenLoading ? 'fa-solid fa-mug-hot fa-spin' : 'fa-solid fa-mug-hot';
    //let exportIcon=this.props.exportLoading?"fa-solid fa-paper-plane fa-spin":"fa-solid fa-paper-plane";
    return (
      <ButtonFooterContainer>
        {this.renderAdvancedSearchButton()}
        <ColButton
          text='Cancel'
          onClick={this.props.panelClickOnCancel}
        />
        <ColButton
          text='Export Report'
          icon='fa-solid fa-file-export'
          disabled={this.props.exportLoading}
          onClick={() => this.props.startExport(this.state.filter)}
        />
        <ColButton
          text='View Report on Screen'
          type='submit'
          icon={screenIcon}
          disabled={this.props.screenLoading}
        />
      </ButtonFooterContainer>
    );
  }

  render() {
    return (
      <PanelBorder
        headerText='Report Filter'
        clickOnCancel={this.props.panelClickOnCancel}
        minWidth='800px'
        icon='fa-solid fa-mug-hot'
        itemToSave={this.state.filter}
        saveType='PlanningReportingFilter'
        onSavedItemChanged={(item) => {
          if (item.UseActualMonth) {
            item.StartDate = dateTimeHelper.firstDayOfTheActualMonth();
            item.EndDate = dateTimeHelper.lastDayOfTheActualMonth();
          }
          this.setState({ filter: item });
          this.props.startSearch(item);
        }}
        saveWindowText='Save Filter'
        openWindowText='Open Filter'
        exportFunction={() => this.props.startExport(this.state.filter)}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.clickOnSubmitButton();
          }}
        >
          <div className='container-fluid'>
            <div className='row'>
              {this.renderInputField('UseActualMonth', 'Use Actual Month', 'col', InputTypesEnum.OnOff)}
              {this.state.filter.UseActualMonth
                ? this.renderInputField('StartDate', 'Start Date', 'col', InputTypesEnum.PlaceHolder)
                : this.renderInputField('StartDate', 'Start Date', 'col', InputTypesEnum.Date)}
              {this.state.filter.UseActualMonth
                ? this.renderInputField('EndDate', 'End Date', 'col', InputTypesEnum.PlaceHolder)
                : this.renderInputField('EndDate', 'End Date', 'col', InputTypesEnum.Date)}
              {this.renderStatusCheckBoxes('col')}
            </div>
            {this.state.advanced && (
              <div className='row'>
                {this.renderInputField('ClientId', 'Client', 'col-6', InputTypesEnum.ClientSelect)}
                {this.renderInputField('ServiceId', 'Service', 'col-6', InputTypesEnum.ServiceSelect)}
                {this.renderOfficeMultiselect('Offices', 'col-4')}
                {this.renderInputField('AccountManagerId', 'Account Manager', 'col-4', InputTypesEnum.UserSelect)}
                {this.renderInputField('CountryId', 'Country', 'col-4', InputTypesEnum.CountrySelect)}
              </div>
            )}
          </div>
          {this.renderButtons()}
        </form>
      </PanelBorder>
    );
  }
}

export default ReportingFilterBox;
